<section class="policy-hero policy-hero--returns" aria-labelledby="returns-title">
  <div class="policy-hero__content">
    <p class="policy-label">Return &amp; Exchange Policy</p>
    <h1 id="returns-title">Simple next steps when the fit is not right.</h1>
    <p class="policy-intro">
      We want you to feel confident with your purchase. Review the guidelines
      below for exchanges, issue reports, eligibility, and support timing.
    </p>
    <div class="policy-meta" aria-label="Return policy highlights">
      <span>Free exchanges within 30 days</span>
      <span>Email us before sending items back</span>
      <span>No return required for confirmed order issues</span>
    </div>
  </div>
</section>

<main class="policy-shell">
  <aside class="policy-summary" aria-labelledby="returns-summary-title">
    <p class="policy-label">In Brief</p>
    <h2 id="returns-summary-title">The essentials</h2>
    <ul>
      <li>
        <strong>30-day exchange window</strong>
        <span>Eligible clothing items can be exchanged within 30 days of delivery.</span>
      </li>
      <li>
        <strong>Keep items resellable</strong>
        <span>Items must be unworn, unwashed, unused, and include tags or packaging when applicable.</span>
      </li>
      <li>
        <strong>Contact support first</strong>
        <span>Send your order details by email and wait for our next steps.</span>
      </li>
    </ul>
  </aside>

  <article class="policy-document">
    <section class="policy-section">
      <h2>Overview</h2>
      <p>
        At {{appname}}, we want you to feel confident and happy with your
        purchase. If something is not quite right, please review our return and
        exchange policy below.
      </p>
    </section>

    <section class="policy-section">
      <h2>Free Exchanges</h2>
      <p>
        We offer free exchanges within <strong>30 days of delivery</strong> for
        eligible clothing items that are unworn, unwashed, unused, and in
        resellable condition, with all original tags and packaging included when
        applicable.
      </p>
      <p>
        Exchanges are subject to item availability. If the requested replacement
        item or size is unavailable, our customer support team will help you
        with the next best available option.
      </p>
    </section>

    <section class="policy-section">
      <h2>Damaged, Defective, or Incorrect Items</h2>
      <p>
        If your item arrives damaged, defective, incorrect, or has an issue
        caused by us, please contact us as soon as possible. Once the issue is
        confirmed, we will provide a refund directly —
        <strong>no return required</strong>.
      </p>
      <p>
        To help us process your request quickly, please include your order
        number, a clear description of the issue, and photos of the item if
        applicable.
      </p>
    </section>

    <section class="policy-section">
      <h2>Final Sale Items</h2>
      <p>
        Final Sale items cannot be returned or exchanged, unless the item
        arrives damaged, defective, incorrect, or has an issue caused by us.
      </p>
    </section>

    <section class="policy-section">
      <h2>How to Request an Exchange or Refund</h2>
      <p>
        To start an exchange or refund request, please email us at
        <a href="mailto:{{email}}" target="_blank">{{email}}</a>.
      </p>
      <p>In your email, please include the following information:</p>
      <ul>
        <li>Your order number</li>
        <li>The item you would like to exchange or report</li>
        <li>The reason for your exchange or refund request</li>
        <li>Photos of the item, if it is damaged, defective, or incorrect</li>
      </ul>
      <p>
        Once we receive your request, our support team will review it and follow
        up with the next steps.
      </p>
    </section>

    <section class="policy-section">
      <h2>Exchange Eligibility</h2>
      <p>
        To be eligible for an exchange, items must meet the following
        conditions:
      </p>
      <ul>
        <li>Requested within 30 days of delivery</li>
        <li>Unworn, unwashed, unused, and free of stains, odors, or damage</li>
        <li>In resellable condition</li>
        <li>With original tags and packaging included when applicable</li>
        <li>Not marked as Final Sale</li>
      </ul>
    </section>

    <section class="policy-section">
      <h2>Processing Time</h2>
      <p>
        After we receive your email request, our team will review your case and
        respond with further instructions. Please do not send any items back
        before contacting us and receiving confirmation from our support team.
      </p>
    </section>

    <section class="policy-section policy-contact">
      <h2>Contact Us</h2>
      <p>
        If you have any questions about returns, exchanges, or your order,
        please contact us at:
      </p>
      <p>
        <strong>Email:</strong>
        <a href="mailto:{{email}}" target="_blank">{{email}}</a>
      </p>
    </section>
  </article>
</main>
